/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'message-items';
const componentName = 'search-replace-pair';
const prefix = `${moduleName}.${componentName}`;

export const searchReplaceStringBreadCrumbTitle = `${prefix}.searchReplaceStringBreadCrumbTitle`;

export const ENGLISH = {
    [searchReplaceStringBreadCrumbTitle]: 'Search Replace String',
};
